import React from 'react';
import { render } from '@testing-library/react';
import { DatePicker } from './DatePicker';

describe('DatePicker', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<DatePicker open data-auto-sel="automation-selector" />
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});

	it('should pass data automation attributes to portal', () => {
		const { container, baseElement } = render(
			<DatePicker
				open
				portalDataAttributes={{
					'data-auto-sel': 'automation-selector',
				}}
			/>
		);

		const nonPortalElement = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);
		const portalElement = baseElement.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(nonPortalElement).toBeNull();
		expect(portalElement).not.toBeNull();
	});
});
